import React from 'react'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, BACK_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import { fetchDetails, scrollToTop } from './Api';



export default function SpeakerPagedetails() {
    const { id } = useParams()

    const [speakers, setspeakers] = useState([])


    useEffect(() => {
        const fetchData = async ({ id }) => {
            const url = `${API_URL}/speakerdetails/${id}`;
            console.log(url);
            const data = await fetchDetails(url);
            if (data) {
                setspeakers(data);
            }
            scrollToTop();
        };
        fetchData({ id });
    }, []);


    return (
        <>

            <main id="tg-main" className="tg-main tg-haslayout">

                <section className="tg-sectionspace tg-haslayout tg-bg" id="tg-about">
                    <div className="container">
                        <div className="row">
                            <div className="tg-aboutus">
                                {speakers.map(speaker => (
                                    <>
                                        <div className="tg-sectionhead tg-textalignleft">
                                            <div className="tg-sectionheading">
                                                <h3>Speaker Details - {speaker.speakername}</h3>
                                            </div>
                                        </div>

                                        {speaker.profiledescription === 'NULL' ? (
                                            <> <div className="col-xs-3 col-sm-12 col-md-3 col-lg-3">
                                                <div className="tg-sectionhead tg-textalignleft">
                                                    <div>
                                                        <img className='spimage' src={`${BACK_URL}/${speaker.image}`} alt="" width="300" height="400" />
                                                        <p>{speaker.designation}</p>
                                                    </div>
                                                </div>
                                            </div></>
                                        ) : <>
                                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                                <div className="tg-sectionhead tg-textalignleft">
                                                    <div>
                                                        <img className='spimage' src={`${BACK_URL}/${speaker.image}`} alt="" width="300" height="400" />
                                                        <p>{speaker.designation}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                                                <div className="tg-description">
                                                    <div style={{ backgroundColor: "" }} dangerouslySetInnerHTML={{ __html: speaker.profiledescription }} />
                                                </div>
                                            </div>
                                        </>}




                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </section >

            </main >
        </>
    )
}